// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /*************************** Body********************************/
 html{
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
   margin: 0;
  
 }
 .aclint-ul{
   padding: 0 0  0 10px; 
   margin: -10px 10px 10px 10px;
 }
 
 #container{
   background-color: #FCFDFD;
 }

/*others*/
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 20px !important;
  margin-bottom: 10px !important;
}









h2 {
  text-align: left;
  color: #0A5090;
  line-height: 145%;
  /*border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;*/
}
h2.callout {
  font-size: 2.0em !important;
}

h3 {
  margin-top: 0;
  text-align: left;
  font-size: 1em;
  font-weight: bold;
  line-height: 185%;
}


p ul {
  padding-left: 40px;
}

a:hover {
  border-bottom: solid 1px transparent;
}
 .maincontent{
  
   margin-top:40px;
 }
 
 

 
#page-numbers {
    list-style: none;
    display: flex;
  }
  
  #page-numbers > li {
    margin-right: 0.3em;
    color: blue;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
  }


 
 #topNav a{
   
   padding-left:0 !important;
   width:100% !important;
   color:white !important;
   text-decoration:none;
   font-size:14px;
  
 }
 

 
 
 Nav NavText Nav a {
   font-size:50px !important;
 }
 
 #topNav{
   background: #2c3e50;
    color: white;
    width:260px;
    min-height:1200px;
    
    
 }
 
 NavText
 {
   width:100% !important;
   float:left !important;
 }

 .carousel-inner
 {
     height:500px;
 }

 .navbar-dark .navbar-toggler{
     border-color:red;
 }

 .body_content{
    padding:20px 50px;
    
}

 .alink{
     color:black !important;
 }
 .alink:hover{
     color : blue;
 }

 .calendar{
   min-width:200px;
    height:318px;
 }
 
 .card-index{
   width: 100%;
   
 }

 @media only screen and (max-width:1200px) {
 #content {
   float: right ;
  
    
 }
 .body_content{
    padding:20px 50px;
    
}
     }


     @media only screen and (max-width:930px) {
      
       .col-3{
           flex: 0 0 !important;
           max-width:0% !important;
       }
       .col-auto{
           width: 90% ;
         }

         .calendar{
           width:300px;
            height:318px;
         }
   }
 @media only screen and (max-width:760px) {
   #topNav{
     background: #2c3e50;
     color: white;
     width: 260px !important;
     z-index:100;
 
   }
   .body_content{
    padding:20px;
    
}
   .carousel-inner
   {
       height:250px;
   }
 
   #content {
     float: right ;
     width: 100% ;
      
   }
   .card-index{
       min-width: 15rem;
      
     }
  
 
   #top Nav{
     max-height:50px !important;
   }
   
   
   #topNav{
       position:fixed;
   }
 
   
 }
 
 .logo-image
 {
   padding-left:0px;
 }
 
 
 
 
  .menu-btn{
   width: 2rem;
   height: 1.5rem;
   font-Weight: 700;
   padding: 5px;
   padding-right: 0px;
   background-Color: #55AAEE 
 
 
 
 }
 
 @media(min-width:951px) {
    .menu-btn {
           display: none
       }
 }
 

 #myBtn {
   /*display: none;*/
   position: fixed;
   bottom: 20px;
   right: 30px;
   z-index: 99;
   font-size: 16px;
   border: none;
   outline: none;
   background-color: red;
   color: white;
   cursor: pointer;
   padding: 15px;
   border-radius: 4px;
   width:120px;
 }

 img.center {
   display: block;
   margin-left: auto;
   margin-right: auto;
   
}
img{
    margin-bottom: 0rem !important;
}
.content{
    width:90%;
    margin:auto;
    padding-top:40px;
   padding-bottom:100px;

}

a.center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width:100%;
}
.center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    
}

a.inputdata{
    display: block;
    margin-left: auto;
    margin-right: auto;
    width:20%;
    margin: 50px auto 100px auto
}
    
 
.card-body li a{
   text-decoration:none;
   
}
.box_index{
min-height:300px !important;
display: block;
margin-left: auto !important;
margin-right: auto !important;
}
.left_content{
   display: block;
   margin-left: auto !important;
   margin-right: auto !important;
}


.other_pages{
    max-width:80% !important;
}

.col-sm{

min-width: 18rem}



@media (max-width:  1040px){

.col-sm-8 {
    flex: 0 0 50%;
    max-width: 50%;
}
.col-sm{
    max-width:100% !important
}
}

@media (max-width: 768px){

    .col-sm-8 {
        flex: 0 0 50%;
        max-width: 55%;
    }
    .col-sm {
    
        max-width: 100%;
    }
    }

    @media (max-width: 575.98px)
     { .col-sm-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;}

        .col-sm{
            max-width:100% !important
        }
    }
    /********************************** Form ************************************************* */

    .form-control1{
        max-width:60px;
        padding:10px !important
    }
    .form-control11{
        max-width:60px;
        padding:10px !important;
        background-color: #ecf0f1

    }
    .form-table{
        width:90%;
    }
    .form-control2{
        width:80%;
        
    }
    @media (max-width: 575.98px)
    {
        .form-control2{
            width:40%;
        }
            
        
    }
    .form-control4{
        width:150px;
        
    }

    .btnsubmit{
        padding-right:auto !important;
        padding-left:auto !important;
       
      
    }
    .btnsubmit button{
        width:150px;
        background-color:#C1C1C1 !important;
        font-weight: 600;
    }
   
      /* ***************************** Table ************************* */

  table, th, td {
    border-bottom: 1px solid lightgray;
    border-collapse: collapse;
}

th, td {
    padding: 15px;
    text-align: left;
    
}

th {
    
    text-align: center;
   }

    /* ********************************************** Collapseable panel ****************************** */

    .wrapper{
      
        width:100%;
      } 
      
      .panel-heading {
        padding: 0;
          border:0;
      }
      .panel-body{
          padding:20px;
      }
      .panel-title>a, .panel-title>a:active{
          display:block;
          padding:15px;
        color:#555;
        font-size:16px;
        font-weight:bold;
          text-transform:uppercase;
          letter-spacing:1px;
        word-spacing:3px;
          text-decoration:none;
      }
  
      
      .panel-heading  a:before {
        font-family: 'Glyphicons Halflings';
        content: "\\e114";
        float: right;
        transition: all 0.5s;
     }
     .panel-heading a:after  {
        transform: rotate(180deg);
       /* font-family: 'Glyphicons Halflings';
      content: "\\e113";
      float: right;
      transition: all 0.5s;*/
    } 
      .popup-content {
          width:600px!important;
          left:100px !important;
          top:150px !important;
      }
      @media(max-width:560px){
        .popup-content {
          width:300px!important;
          left:50px !important;
          top:150px !important;
          position: absolute !important;
      }
      }

 /* ****************************** Header ************************* */

   .header {
       position: relative
   }
   
   .banner {
       width: 100%;
       height: 3px; 
      
       background-color: rgba(0, 0, 0, 0.15);
   }
   
   @media(min-width:320px) {
       .header .usa-nav-close {
           display: none
       }
   }
   
   
   .globalNav {
       margin: 0 0 2rem;
       flex-direction: column
   }
   
   .globalNav, .globalNav   {
           display: flex
       }
   
   .globalNav   {
               list-style-type: none;
               justify-content: space-around;
               background-color: #eee
           }
   
   .globalNav   li {
                   width: 100%;
                   text-align: center;
                   border-right: 1px solid #bbb;
                   font-size: 1.2rem;
                   margin: 0
               }
   .globalNav {
       margin: 0 0 0;
   }
   @media(min-width:555px) {
       .globalNav   li {
           font-size: 1.4rem
       }
   }
   
   
   .siteNav_menuToggle usa-menu-btn{
       padding-top:0;
       float:right;
     
   }
   .globalNav   li:last-of-type {
       border-right: none
   }
   
   .globalNav   a {
       text-decoration: none;
       color: #036;
       padding: 12px 2px;
       line-height: 1;
       display: block;
       width: 100%;
       height: 100%;
       font-weight: 800
   }
   
   .globalNav   a:focus, .globalNav   a:hover {
           background-color: #ddd
       }
   
   .globalNav  a:focus {
           box-shadow: #0071bb
       }
   
   .globalNav   a:active {
           color: #fff;
           background-color: #0071bb;
           transition: all .1s ease-in-out
       }
   
   .globalNav   a.active {
           color: #fff;
           background-color: #0071bb
       }
   
     
   
   .globalNav__description {
       background-color: #036;
       color: #fff;
       display: flex;
       flex-direction: row-reverse;
       justify-content: space-between;
       align-items: center;
       padding: 0 3rem
   }
   
   .globalNav__description p {
           font-size: 1.0rem;
           margin: 0;
           line-height: 1.2;
           margin-right: 1.2rem;
           padding: .6rem
       }
   
   .header_logo {
           padding: 1.5rem;
           display: flex;
           flex-direction: row-reverse;
           align-items: center;
           justify-content: space-between;
           background-color:white;
      
       }
   
   .header_logo_logo {
      
           
           margin-left: 2rem;
           
       }

       .nav-item{
        padding-right:40px;
      
    }
    .nav-link {
        font-weight:600 !important;
        font-size:15px;
        color:white !important;
        text-align: center;
       
    }
    .nav-link:hover { 
        background-color: #665;
    }

    .dropdown-menu{
        width:300px;
        padding:20px !important;
    }

    .dropdown-menu a{
       text-decoration: none;
        color:black;
    }

    .dropdown-menu a:hover{
        text-decoration: none;
         color:black;
         background-color:#666655
     }
   @media(min-width:760px) {
           .header_logo_logo {
               margin-left: 0;
               margin-right: 10rem
           }
       }
       @media(max-width:990px){
           #topNav{
               display:none;
            }
       }
       @media(max-width:760px) {
       .header_logo_logo {
           width: 70%;
           
         
           
       }
      
   }
   
      
   .logo-image{
       float:left;
     padding-left:30px;
     padding-bottom:5px;
     max-width: 100%;
     
    padding-top:5px;
   }
   @media only screen and (max-width:530px) {
       
     .logo-image
     {
       padding-left:0px;
     }
       }
  .aclintranet_subpage{
           width:90%;
           margin: auto;
       }
  /****************************** Footer *****************************************/
.footer__content {
       background-color :#08508F;
       display: flex;
       flex-direction: column;
       align-items: center;
       padding: 3rem;
       z-index:100;
       
   }
   @media(min-width:320px) {
       .footer__content {
           flex-direction: row;
           justify-content: space-between
       }
   }

   #footer a{
       color:white;
       line-height: 20px;
       font-size:14px !important;
   }
   #footer a:hover {
       color: black;
       text-decoration: underline;
   }
   
   a {
      
       text-decoration: none;
   }
   
   .footer__content ul {
       list-style-type: none
   }
   
   .footer__content h3 {
       margin-top: 0;
       font-size: 1.2rem;
       font-family: source-sans-pro,helvetica,arial,sans-serif
   }
   
   .footer__content li {
       font-size: 1.0rem
   }
   
   .footer__content__section {
       display: flex;
       flex-flow: row wrap
   }
   
   .footer__content__section--links div {
       margin-right: 3rem;
       margin-bottom: 3rem
       }
   
   .footer__content__section--logos {
       margin-bottom: 3rem
   }
   
    
   .footer__content__section--logos li {
           width: 15rem;
           text-align: center
       }
   
     @media only screen and(max-width:760){
   
           .footer__content__section--logos ul li {
               padding-bottom:100px;
       }
       }
   
   @media(min-width:320px) {
       .footer__content__section--logos {
           order: 4;
           justify-self: flex-end
       }
   }
   
   .footer__content__section footer__content__section--links ul li a {
       text-decoration: none;
   }

   .nav-link {
    font-weight:600 !important;
    font-size:16px;
    color:black !important;
    text-align: center;
   
}
   /* ********************************* Responsive Table ********************************** */
   .logo-image{
    float:left;
  padding-left:30px;
  padding-bottom:5px;
  max-width: 100%;
  Width:250px;
  
 padding-top:5px;
}
@media only screen and (max-width:530px) {
    
  .logo-image
  {
    padding-left:0px;
  }
    }
   

    .modal {
        font-size: 12px;
      }
      .modal > .header {
        width: 100%;
        border-bottom: 1px solid gray;
        font-size: 18px;
        text-align: center;
        padding: 5px;
      }
      .modal > .content {
        width: 100%;
        padding: 10px 5px;
      }
      .modal > .actions {
        width: 100%;
        padding: 10px 5px;
        margin: auto;
        text-align: center;
      }
      .modal > .close {
        cursor: pointer;
        position: absolute;
        display: block;
        padding: 2px 5px;
        line-height: 20px;
        right: -10px;
        top: -10px;
        font-size: 24px;
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid #cfcece;
      }

      .demo-root {
        width: 90%;
        display: flex;
        font-family: Roboto;
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }
      .demo-label {
        display: block;
        font-size: 20px;
        font-weight: 500;
        margin: 50px 0 25px;
      }
      .demo-label-high {
        display: block;
        font-size: 20px;
        font-weight: 500;
        margin: 50px 0 90px;
      }
      .demo-subLabel {
        margin-bottom: 20px;
      }
      .demo-editorSection {
        display: flex;
        justify-content: space-between;
      }
      .demo-wrapper {
        width: 100% !important;
        display: block !important;
        margin-bottom: 25px !important;
        height: 400px !important;
      }
      .demo-wrapper-medium {
        width: 650px !important;
        display: block !important;
        margin-bottom: 50px !important;
        height: 300px !important;
      }
      .demo-editor {
        height: 275px !important;
        border: 1px solid #C0C0C0 !important;
        padding: 5px !important;
        border-radius: 2px !important;
      }
      .demo-editorWrapper {
      }
      .demo-content {
        border: 1px solid #F1F1F1;
        padding: 5px;
        width: 100%;
        border-radius: 2px;
        resize: none;
        height: 200px;
      }

  

      
      .rdw-editor-toolbar[aria-hidden="false"] {
        visibility: visible;
        height: auto; /* Element is visible and takes up its natural height */
      }
      
      /* When aria-hidden is set to "true" */
      .rdw-editor-toolbar[aria-hidden="true"] {
        visibility: hidden;
        height: 0; /* Element is hidden and its height is collapsed */
      }
      .demo-toolbar-absolute {
       
        top: 120px !important;
        width: 550px !important;
        border-radius: 3px !important;
        background: #f3f3f3 !important;
        border: 1px solid #e3e3e3 !important;
      }
      .demo-toolbar-absolute-high {
        position: absolute !important;
        top: -80px !important;
        width: 550px !important;
        border-radius: 3px !important;
        background: #f3f3f3 !important;
        border: 1px solid #e3e3e3 !important;
      }
      .demo-editor-plain {
        height: 80% !important;
        border-width: 0px !important;
      }
      .demo-editor-embedded {
        height: 90% !important;
        border-width: 0px !important;
      }
      .demo-wrapper-relative {
        display: block !important;
        position: relative !important;
        margin-bottom: 25px !important;
        height: 200px !important;
      }
      .demo-wrapper-relative-long {
        width: 715px !important;
        display: block !important;
        position: relative !important;
        margin-bottom: 25px !important;
        height: 450px !important;
      }
      .bordered-option-classname {
        border: 1px solid #e3e3e3 !important;
      }
      .demo-toolbar-absolute > div:not(:last-of-type) {
        border-right: 2px solid #e3e3e3;
        padding-right: 5px;
      }
      .demo-toolbar-absolute > div:not(:first-of-type) {
        padding-left: 5px;
      }
      .demo-toolbar-custom {
        border-color: rgb(0,47,126) !important;
        background-color: #9EBEF5 !important;
      }
      .demo-editor-custom {
        height: 200px !important;
        border: 1px solid #c0bbbb !important;
        padding: 5px !important;
        height: 75% !important;
        border-radius: 2px !important;
        border-color: rgb(0,47,126) !important;
      }
      .demo-option-custom {
        width: 15px !important;
        height: 15px !important;
        border-color: rgb(0,47,126) !important;
        color: rgb(0,47,126);
      }
      .demo-option-custom-wide {
        width: 125px !important;
        height: 25px !important;
        border-color: rgb(0,47,126) !important;
        color: rgb(0,47,126) !important;
      }
      .demo-option-custom-medium {
        height: 25px !important;
        border-color: rgb(0,47,126) !important;
        color: rgb(0,47,126) !important;
      }
      .demo-dropdown-custom {
        border-color: rgb(0,47,126) !important;
      }
      .demo-popup-custom {
        border-color: rgb(0,47,126) !important;
        padding: 5px !important;
      }
      .demo-popup-custom input {
        border-color: rgb(0,47,126) !important;
      }
      .demo-popup-custom button {
        border-color: rgb(0,47,126) !important;
      }
      .demo-section-wrapper {
        display: flex;
      }
      .demo-editor-wrapper {
        width: 60%;
      }
      .demo-section {
        margin: 50px 30px 20px;
        width: 95%;
      }
      .ReactCodeMirror {
        width: 38%;
        margin-left: 2%;
        border: 1px solid #e4e4e4;
        height: 400px;
      }
      .CodeMirror {
        height: 400px !important;
      }
      .demo-custom-option {
        width: 26px;
        height: 26px;
        border: 1px solid #f1f1f1;
        text-align: center;
        padding-right: 5px;
        padding-bottom: 2px;
        cursor: pointer;
      }
      .DraftEditor-editorContainer{
        font-size:16px;
      }
      
      .blue-black-card {
        background-color: #0557aa;  /* blue-black background */
        color: white;  /* text color */
        border-radius: 10px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        height:300px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
    
    .blue-black-card:hover {
      background-color: #2086ec;  
    }

    .blue-black-button {
      background-color: #0557aa;  
    }

    .blue-black-button:hover {
      background-color: #2086ec;  
    }
    .icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
    }
    a.block:hover{
      text-decoration: none;
    }

    .usa-banner__inner {
      margin-left: inherit !important;
    }

  #react-select-3-placeholder{
      color: #333
  }
  .css-1jqq78o-placeholder {
    color: #333 !important
}
.css-1fw11w8-Button{
color: black !important
}

.rdw-dropdown-selectedtext img::after {
  content: "Font Size Icon" !important
}

.rdw-dropdown-selectedtext img {
  content: "Font Size Icon" !important
}`, "",{"version":3,"sources":["webpack://./src/styles/custom.css"],"names":[],"mappings":"CAAC,iEAAiE;CACjE;IACG,4DAA4D;AAChE;AACA;GACG,SAAS;;CAEX;CACA;GACE,oBAAoB;GACpB,4BAA4B;CAC9B;;CAEA;GACE,yBAAyB;CAC3B;;AAED,SAAS;AACT;;;;;;EAME,2BAA2B;EAC3B,8BAA8B;AAChC;;;;;;;;;;AAUA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB;iCAC+B;AACjC;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;CACC;;GAEE,eAAe;CACjB;;;;;AAKD;IACI,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;EACjB;;;;CAID;;GAEE,yBAAyB;GACzB,qBAAqB;GACrB,sBAAsB;GACtB,oBAAoB;GACpB,cAAc;;CAEhB;;;;;CAKA;GACE,yBAAyB;CAC3B;;CAEA;GACE,mBAAmB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;;;CAGpB;;CAEA;;GAEE,qBAAqB;GACrB,qBAAqB;CACvB;;CAEA;;KAEI,YAAY;CAChB;;CAEA;KACI,gBAAgB;CACpB;;CAEA;IACG,iBAAiB;;AAErB;;CAEC;KACI,sBAAsB;CAC1B;CACA;KACI,YAAY;CAChB;;CAEA;GACE,eAAe;IACd,YAAY;CACf;;CAEA;GACE,WAAW;;CAEb;;CAEA;CACA;GACE,aAAa;;;CAGf;CACA;IACG,iBAAiB;;AAErB;KACK;;;KAGA;;OAEE;WACI,oBAAsB;WACtB,uBAAuB;OAC3B;OACA;WACI,WAAW;SACb;;SAEA;WACE,WAAW;YACV,YAAY;SACf;GACN;CACF;GACE;KACE,mBAAmB;KACnB,YAAY;KACZ,uBAAuB;KACvB,WAAW;;GAEb;GACA;IACC,YAAY;;AAEhB;GACG;;OAEI,YAAY;GAChB;;GAEA;KACE,aAAa;KACb,YAAY;;GAEd;GACA;OACI,gBAAgB;;KAElB;;;GAGF;KACE,0BAA0B;GAC5B;;;GAGA;OACI,cAAc;GAClB;;;CAGF;;CAEA;;GAEE,gBAAgB;CAClB;;;;;EAKC;GACC,WAAW;GACX,cAAc;GACd,gBAAgB;GAChB,YAAY;GACZ,kBAAkB;GAClB;;;;CAIF;;CAEA;IACG;WACO;OACJ;CACN;;;CAGA;GACE,iBAAiB;GACjB,eAAe;GACf,YAAY;GACZ,WAAW;GACX,WAAW;GACX,eAAe;GACf,YAAY;GACZ,aAAa;GACb,qBAAqB;GACrB,YAAY;GACZ,eAAe;GACf,aAAa;GACb,kBAAkB;GAClB,WAAW;CACb;;CAEA;GACE,cAAc;GACd,iBAAiB;GACjB,kBAAkB;;AAErB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;GACjB,oBAAoB;;AAEvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT;AACJ;;;AAGA;GACG,oBAAoB;;AAEvB;AACA;AACA,2BAA2B;AAC3B,cAAc;AACd,4BAA4B;AAC5B,6BAA6B;AAC7B;AACA;GACG,cAAc;GACd,4BAA4B;GAC5B,6BAA6B;AAChC;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;;AAEA,gBAAgB;;;;AAIhB;;AAEA;IAEI,aAAa;IACb,cAAc;AAClB;AACA;IACI;AACJ;AACA;;AAEA;;IAEI;QAEI,aAAa;QACb,cAAc;IAClB;IACA;;QAEI,eAAe;IACnB;IACA;;IAEA;OACG;QAEC,yBAAyB;QACzB,0BAA0B,CAAC;;QAE3B;YACI;QACJ;IACJ;IACA,4FAA4F;;IAE5F;QACI,cAAc;QACd;IACJ;IACA;QACI,cAAc;QACd,uBAAuB;QACvB;;IAEJ;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;;IAEb;IACA;;QAEI;YACI,SAAS;QACb;;;IAGJ;IACA;QACI,WAAW;;IAEf;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;;;IAGhC;IACA;QACI,WAAW;QACX,mCAAmC;QACnC,gBAAgB;IACpB;;MAEE,kEAAkE;;EAEtE;IACE,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;;AAEpB;;AAEA;;IAEI,kBAAkB;GACnB;;IAEC,qGAAqG;;IAErG;;QAEI,UAAU;MACZ;;MAEA;QACE,UAAU;UACR,QAAQ;MACZ;MACA;UACI,YAAY;MAChB;MACA;UACI,aAAa;UACb,YAAY;QACd,UAAU;QACV,cAAc;QACd,gBAAgB;UACd,wBAAwB;UACxB,kBAAkB;QACpB,gBAAgB;UACd,oBAAoB;MACxB;;;MAGA;QACE,mCAAmC;QACnC,gBAAgB;QAChB,YAAY;QACZ,oBAAoB;KACvB;KACA;QAGG,yBAAyB;OAC1B;;;4BAGqB;IACxB;MACE;UACI,qBAAqB;UACrB,qBAAqB;UACrB,oBAAoB;MACxB;MACA;QACE;UACE,qBAAqB;UACrB,oBAAoB;UACpB,oBAAoB;UACpB,6BAA6B;MACjC;MACA;;CAEL,oEAAoE;;GAElE;OACI;GACJ;;GAEA;OACI,WAAW;OACX,WAAW;;OAEX,qCAAqC;GACzC;;GAEA;OACI;WACI;OACJ;GACJ;;;GAGA;OACI,gBAAgB;OAIhB;GACJ;;GAEA;WAGQ;OACJ;;GAEJ;eACY,qBAAqB;eAErB,6BAA6B;eAC7B;WACJ;;GAER;mBACgB,WAAW;mBACX,kBAAkB;mBAClB,4BAA4B;mBAC5B,iBAAiB;mBACjB;eACJ;GACZ;OACI,aAAa;GACjB;GACA;OACI;WACI;OACJ;GACJ;;;GAGA;OACI,aAAa;OACb,WAAW;;GAEf;GACA;OACI;GACJ;;GAEA;OACI,qBAAqB;OACrB,WAAW;OACX,iBAAiB;OACjB,cAAc;OACd,cAAc;OACd,WAAW;OACX,YAAY;OACZ;GACJ;;GAEA;WACQ;OACJ;;GAEJ;WACQ;OACJ;;GAEJ;WACQ,WAAW;WACX,yBAAyB;WACzB;OACJ;;GAEJ;WACQ,WAAW;WACX;OACJ;;;;GAIJ;OACI,sBAAsB;OACtB,WAAW;OAGX,aAAa;OAIb,2BAA2B;OAG3B,8BAA8B;OAG9B,mBAAmB;OACnB;GACJ;;GAEA;WACQ,iBAAiB;WACjB,SAAS;WACT,gBAAgB;WAChB,oBAAoB;WACpB;OACJ;;GAEJ;WACQ,eAAe;WAGf,aAAa;WAIb,2BAA2B;WAG3B,mBAAmB;WAGnB,8BAA8B;WAC9B,sBAAsB;;OAE1B;;GAEJ;;;WAGQ,iBAAiB;;OAErB;;OAEA;QACC,kBAAkB;;IAEtB;IACA;QACI,0BAA0B;QAC1B,cAAc;QACd,sBAAsB;QACtB,kBAAkB;;IAEtB;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;OACG,qBAAqB;QACpB,WAAW;IACf;;IAEA;QACI,qBAAqB;SACpB,WAAW;SACX;KACJ;GACF;WACQ;eACI,cAAc;eACd;WACJ;OACJ;OACA;WACI;eACI,YAAY;YACf;OACL;OACA;OACA;WACI,UAAU;;;;OAId;;GAEJ;;;GAGA;OACI,UAAU;KACZ,iBAAiB;KACjB,kBAAkB;KAClB,eAAe;;IAEhB,eAAe;GAChB;GACA;;KAEE;;OAEE,gBAAgB;KAClB;OACE;EACL;WACS,SAAS;WACT,YAAY;OAChB;EACL,gFAAgF;AAClF;OACO,yBAAyB;OAGzB,aAAa;OAIb,sBAAsB;OAGtB,mBAAmB;OACnB,aAAa;OACb,WAAW;;GAEf;GACA;OACI;WAII,mBAAmB;WAGnB;OACJ;GACJ;;GAEA;OACI,WAAW;OACX,iBAAiB;OACjB,yBAAyB;GAC7B;GACA;OACI,YAAY;OACZ,0BAA0B;GAC9B;;GAEA;;OAEI,qBAAqB;GACzB;;GAEA;OACI;GACJ;;GAEA;OACI,aAAa;OACb,iBAAiB;OACjB;GACJ;;GAEA;OACI;GACJ;;GAEA;OAGI,aAAa;OAIb;GACJ;;GAEA;OACI,kBAAkB;OAClB;OACA;;GAEJ;OACI;GACJ;;;GAGA;WACQ,YAAY;WACZ;OACJ;;KAEF;;WAEM;eACI,oBAAoB;OAC5B;OACA;;GAEJ;OACI;WAGI,QAAQ;WACR;OACJ;GACJ;;GAEA;OACI,qBAAqB;GACzB;;GAEA;IACC,0BAA0B;IAC1B,cAAc;IACd,sBAAsB;IACtB,kBAAkB;;AAEtB;GACG,0FAA0F;GAC1F;IACC,UAAU;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;;CAEZ,eAAe;AAChB;AACA;;EAEE;;IAEE,gBAAgB;EAClB;IACE;;;IAGA;QACI,eAAe;MACjB;MACA;QACE,WAAW;QACX,6BAA6B;QAC7B,eAAe;QACf,kBAAkB;QAClB,YAAY;MACd;MACA;QACE,WAAW;QACX,iBAAiB;MACnB;MACA;QACE,WAAW;QACX,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;MACpB;MACA;QACE,eAAe;QACf,kBAAkB;QAClB,cAAc;QACd,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,UAAU;QACV,eAAe;QACf,mBAAmB;QACnB,mBAAmB;QACnB,yBAAyB;MAC3B;;MAEA;QACE,UAAU;QACV,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,sBAAsB;QACtB,uBAAuB;MACzB;MACA;QACE,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,mBAAmB;MACrB;MACA;QACE,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,mBAAmB;MACrB;MACA;QACE,mBAAmB;MACrB;MACA;QACE,aAAa;QACb,8BAA8B;MAChC;MACA;QACE,sBAAsB;QACtB,yBAAyB;QACzB,8BAA8B;QAC9B,wBAAwB;MAC1B;MACA;QACE,uBAAuB;QACvB,yBAAyB;QACzB,8BAA8B;QAC9B,wBAAwB;MAC1B;MACA;QACE,wBAAwB;QACxB,oCAAoC;QACpC,uBAAuB;QACvB,6BAA6B;MAC/B;MACA;MACA;MACA;QACE,yBAAyB;QACzB,YAAY;QAEZ,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,aAAa;MACf;;;;;MAKA;QACE,mBAAmB;QACnB,YAAY,EAAE,uDAAuD;MACvE;;MAEA,sCAAsC;MACtC;QACE,kBAAkB;QAClB,SAAS,EAAE,kDAAkD;MAC/D;MACA;;QAEE,qBAAqB;QACrB,uBAAuB;QACvB,6BAA6B;QAC7B,8BAA8B;QAC9B,oCAAoC;MACtC;MACA;QACE,6BAA6B;QAC7B,qBAAqB;QACrB,uBAAuB;QACvB,6BAA6B;QAC7B,8BAA8B;QAC9B,oCAAoC;MACtC;MACA;QACE,sBAAsB;QACtB,4BAA4B;MAC9B;MACA;QACE,sBAAsB;QACtB,4BAA4B;MAC9B;MACA;QACE,yBAAyB;QACzB,6BAA6B;QAC7B,8BAA8B;QAC9B,wBAAwB;MAC1B;MACA;QACE,uBAAuB;QACvB,yBAAyB;QACzB,6BAA6B;QAC7B,8BAA8B;QAC9B,wBAAwB;MAC1B;MACA;QACE,oCAAoC;MACtC;MACA;QACE,+BAA+B;QAC/B,kBAAkB;MACpB;MACA;QACE,iBAAiB;MACnB;MACA;QACE,sCAAsC;QACtC,oCAAoC;MACtC;MACA;QACE,wBAAwB;QACxB,oCAAoC;QACpC,uBAAuB;QACvB,sBAAsB;QACtB,6BAA6B;QAC7B,sCAAsC;MACxC;MACA;QACE,sBAAsB;QACtB,uBAAuB;QACvB,sCAAsC;QACtC,oBAAoB;MACtB;MACA;QACE,uBAAuB;QACvB,uBAAuB;QACvB,sCAAsC;QACtC,+BAA+B;MACjC;MACA;QACE,uBAAuB;QACvB,sCAAsC;QACtC,+BAA+B;MACjC;MACA;QACE,sCAAsC;MACxC;MACA;QACE,sCAAsC;QACtC,uBAAuB;MACzB;MACA;QACE,sCAAsC;MACxC;MACA;QACE,sCAAsC;MACxC;MACA;QACE,aAAa;MACf;MACA;QACE,UAAU;MACZ;MACA;QACE,sBAAsB;QACtB,UAAU;MACZ;MACA;QACE,UAAU;QACV,eAAe;QACf,yBAAyB;QACzB,aAAa;MACf;MACA;QACE,wBAAwB;MAC1B;MACA;QACE,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;MACjB;MACA;QACE,cAAc;MAChB;;MAEA;QACE,yBAAyB,GAAG,0BAA0B;QACtD,YAAY,GAAG,eAAe;QAC9B,mBAAmB;QACnB,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,YAAY;QACZ,wCAAwC;IAC5C;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;IACvB;IACA;MACE,qBAAqB;IACvB;;IAEA;MACE,+BAA+B;IACjC;;EAEF;MACI;EACJ;EACA;IACE;AACJ;AACA;AACA;AACA;;AAEA;EACE;AACF;;AAEA;EACE;AACF","sourcesContent":[" /*************************** Body********************************/\n html{\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\nbody {\n   margin: 0;\n  \n }\n .aclint-ul{\n   padding: 0 0  0 10px; \n   margin: -10px 10px 10px 10px;\n }\n \n #container{\n   background-color: #FCFDFD;\n }\n\n/*others*/\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 20px !important;\n  margin-bottom: 10px !important;\n}\n\n\n\n\n\n\n\n\n\nh2 {\n  text-align: left;\n  color: #0A5090;\n  line-height: 145%;\n  /*border-top: 1px solid #ccc;\n  border-bottom: 1px solid #ccc;*/\n}\nh2.callout {\n  font-size: 2.0em !important;\n}\n\nh3 {\n  margin-top: 0;\n  text-align: left;\n  font-size: 1em;\n  font-weight: bold;\n  line-height: 185%;\n}\n\n\np ul {\n  padding-left: 40px;\n}\n\na:hover {\n  border-bottom: solid 1px transparent;\n}\n .maincontent{\n  \n   margin-top:40px;\n }\n \n \n\n \n#page-numbers {\n    list-style: none;\n    display: flex;\n  }\n  \n  #page-numbers > li {\n    margin-right: 0.3em;\n    color: blue;\n    user-select: none;\n    cursor: pointer;\n  }\n\n\n \n #topNav a{\n   \n   padding-left:0 !important;\n   width:100% !important;\n   color:white !important;\n   text-decoration:none;\n   font-size:14px;\n  \n }\n \n\n \n \n Nav NavText Nav a {\n   font-size:50px !important;\n }\n \n #topNav{\n   background: #2c3e50;\n    color: white;\n    width:260px;\n    min-height:1200px;\n    \n    \n }\n \n NavText\n {\n   width:100% !important;\n   float:left !important;\n }\n\n .carousel-inner\n {\n     height:500px;\n }\n\n .navbar-dark .navbar-toggler{\n     border-color:red;\n }\n\n .body_content{\n    padding:20px 50px;\n    \n}\n\n .alink{\n     color:black !important;\n }\n .alink:hover{\n     color : blue;\n }\n\n .calendar{\n   min-width:200px;\n    height:318px;\n }\n \n .card-index{\n   width: 100%;\n   \n }\n\n @media only screen and (max-width:1200px) {\n #content {\n   float: right ;\n  \n    \n }\n .body_content{\n    padding:20px 50px;\n    \n}\n     }\n\n\n     @media only screen and (max-width:930px) {\n      \n       .col-3{\n           flex: 0 0 0 !important;\n           max-width:0% !important;\n       }\n       .col-auto{\n           width: 90% ;\n         }\n\n         .calendar{\n           width:300px;\n            height:318px;\n         }\n   }\n @media only screen and (max-width:760px) {\n   #topNav{\n     background: #2c3e50;\n     color: white;\n     width: 260px !important;\n     z-index:100;\n \n   }\n   .body_content{\n    padding:20px;\n    \n}\n   .carousel-inner\n   {\n       height:250px;\n   }\n \n   #content {\n     float: right ;\n     width: 100% ;\n      \n   }\n   .card-index{\n       min-width: 15rem;\n      \n     }\n  \n \n   #top Nav{\n     max-height:50px !important;\n   }\n   \n   \n   #topNav{\n       position:fixed;\n   }\n \n   \n }\n \n .logo-image\n {\n   padding-left:0px;\n }\n \n \n \n \n  .menu-btn{\n   width: 2rem;\n   height: 1.5rem;\n   font-Weight: 700;\n   padding: 5px;\n   padding-right: 0px;\n   background-Color: #55AAEE \n \n \n \n }\n \n @media(min-width:951px) {\n    .menu-btn {\n           display: none\n       }\n }\n \n\n #myBtn {\n   /*display: none;*/\n   position: fixed;\n   bottom: 20px;\n   right: 30px;\n   z-index: 99;\n   font-size: 16px;\n   border: none;\n   outline: none;\n   background-color: red;\n   color: white;\n   cursor: pointer;\n   padding: 15px;\n   border-radius: 4px;\n   width:120px;\n }\n\n img.center {\n   display: block;\n   margin-left: auto;\n   margin-right: auto;\n   \n}\nimg{\n    margin-bottom: 0rem !important;\n}\n.content{\n    width:90%;\n    margin:auto;\n    padding-top:40px;\n   padding-bottom:100px;\n\n}\n\na.center {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    width:100%;\n}\n.center {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    \n}\n\na.inputdata{\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    width:20%;\n    margin: 50px auto 100px auto\n}\n    \n \n.card-body li a{\n   text-decoration:none;\n   \n}\n.box_index{\nmin-height:300px !important;\ndisplay: block;\nmargin-left: auto !important;\nmargin-right: auto !important;\n}\n.left_content{\n   display: block;\n   margin-left: auto !important;\n   margin-right: auto !important;\n}\n\n\n.other_pages{\n    max-width:80% !important;\n}\n\n.col-sm{\n\nmin-width: 18rem}\n\n\n\n@media (max-width:  1040px){\n\n.col-sm-8 {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n}\n.col-sm{\n    max-width:100% !important\n}\n}\n\n@media (max-width: 768px){\n\n    .col-sm-8 {\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 55%;\n    }\n    .col-sm {\n    \n        max-width: 100%;\n    }\n    }\n\n    @media (max-width: 575.98px)\n     { .col-sm-8 {\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100% !important;\n        max-width: 100% !important;}\n\n        .col-sm{\n            max-width:100% !important\n        }\n    }\n    /********************************** Form ************************************************* */\n\n    .form-control1{\n        max-width:60px;\n        padding:10px !important\n    }\n    .form-control11{\n        max-width:60px;\n        padding:10px !important;\n        background-color: #ecf0f1\n\n    }\n    .form-table{\n        width:90%;\n    }\n    .form-control2{\n        width:80%;\n        \n    }\n    @media (max-width: 575.98px)\n    {\n        .form-control2{\n            width:40%;\n        }\n            \n        \n    }\n    .form-control4{\n        width:150px;\n        \n    }\n\n    .btnsubmit{\n        padding-right:auto !important;\n        padding-left:auto !important;\n       \n      \n    }\n    .btnsubmit button{\n        width:150px;\n        background-color:#C1C1C1 !important;\n        font-weight: 600;\n    }\n   \n      /* ***************************** Table ************************* */\n\n  table, th, td {\n    border-bottom: 1px solid lightgray;\n    border-collapse: collapse;\n}\n\nth, td {\n    padding: 15px;\n    text-align: left;\n    \n}\n\nth {\n    \n    text-align: center;\n   }\n\n    /* ********************************************** Collapseable panel ****************************** */\n\n    .wrapper{\n      \n        width:100%;\n      } \n      \n      .panel-heading {\n        padding: 0;\n          border:0;\n      }\n      .panel-body{\n          padding:20px;\n      }\n      .panel-title>a, .panel-title>a:active{\n          display:block;\n          padding:15px;\n        color:#555;\n        font-size:16px;\n        font-weight:bold;\n          text-transform:uppercase;\n          letter-spacing:1px;\n        word-spacing:3px;\n          text-decoration:none;\n      }\n  \n      \n      .panel-heading  a:before {\n        font-family: 'Glyphicons Halflings';\n        content: \"\\e114\";\n        float: right;\n        transition: all 0.5s;\n     }\n     .panel-heading a:after  {\n        -webkit-transform: rotate(180deg);\n        -moz-transform: rotate(180deg);\n        transform: rotate(180deg);\n       /* font-family: 'Glyphicons Halflings';\n      content: \"\\e113\";\n      float: right;\n      transition: all 0.5s;*/\n    } \n      .popup-content {\n          width:600px!important;\n          left:100px !important;\n          top:150px !important;\n      }\n      @media(max-width:560px){\n        .popup-content {\n          width:300px!important;\n          left:50px !important;\n          top:150px !important;\n          position: absolute !important;\n      }\n      }\n\n /* ****************************** Header ************************* */\n\n   .header {\n       position: relative\n   }\n   \n   .banner {\n       width: 100%;\n       height: 3px; \n      \n       background-color: rgba(0, 0, 0, 0.15);\n   }\n   \n   @media(min-width:320px) {\n       .header .usa-nav-close {\n           display: none\n       }\n   }\n   \n   \n   .globalNav {\n       margin: 0 0 2rem;\n       -webkit-box-orient: vertical;\n       -webkit-box-direction: normal;\n       -ms-flex-direction: column;\n       flex-direction: column\n   }\n   \n   .globalNav, .globalNav   {\n           display: -webkit-box;\n           display: -ms-flexbox;\n           display: flex\n       }\n   \n   .globalNav   {\n               list-style-type: none;\n               -ms-flex-pack: distribute;\n               justify-content: space-around;\n               background-color: #eee\n           }\n   \n   .globalNav   li {\n                   width: 100%;\n                   text-align: center;\n                   border-right: 1px solid #bbb;\n                   font-size: 1.2rem;\n                   margin: 0\n               }\n   .globalNav {\n       margin: 0 0 0;\n   }\n   @media(min-width:555px) {\n       .globalNav   li {\n           font-size: 1.4rem\n       }\n   }\n   \n   \n   .siteNav_menuToggle usa-menu-btn{\n       padding-top:0;\n       float:right;\n     \n   }\n   .globalNav   li:last-of-type {\n       border-right: none\n   }\n   \n   .globalNav   a {\n       text-decoration: none;\n       color: #036;\n       padding: 12px 2px;\n       line-height: 1;\n       display: block;\n       width: 100%;\n       height: 100%;\n       font-weight: 800\n   }\n   \n   .globalNav   a:focus, .globalNav   a:hover {\n           background-color: #ddd\n       }\n   \n   .globalNav  a:focus {\n           box-shadow: #0071bb\n       }\n   \n   .globalNav   a:active {\n           color: #fff;\n           background-color: #0071bb;\n           transition: all .1s ease-in-out\n       }\n   \n   .globalNav   a.active {\n           color: #fff;\n           background-color: #0071bb\n       }\n   \n     \n   \n   .globalNav__description {\n       background-color: #036;\n       color: #fff;\n       display: -webkit-box;\n       display: -ms-flexbox;\n       display: flex;\n       -webkit-box-orient: horizontal;\n       -webkit-box-direction: reverse;\n       -ms-flex-direction: row-reverse;\n       flex-direction: row-reverse;\n       -webkit-box-pack: justify;\n       -ms-flex-pack: justify;\n       justify-content: space-between;\n       -webkit-box-align: center;\n       -ms-flex-align: center;\n       align-items: center;\n       padding: 0 3rem\n   }\n   \n   .globalNav__description p {\n           font-size: 1.0rem;\n           margin: 0;\n           line-height: 1.2;\n           margin-right: 1.2rem;\n           padding: .6rem\n       }\n   \n   .header_logo {\n           padding: 1.5rem;\n           display: -webkit-box;\n           display: -ms-flexbox;\n           display: flex;\n           -webkit-box-orient: horizontal;\n           -webkit-box-direction: reverse;\n           -ms-flex-direction: row-reverse;\n           flex-direction: row-reverse;\n           -webkit-box-align: center;\n           -ms-flex-align: center;\n           align-items: center;\n           -webkit-box-pack: justify;\n           -ms-flex-pack: justify;\n           justify-content: space-between;\n           background-color:white;\n      \n       }\n   \n   .header_logo_logo {\n      \n           \n           margin-left: 2rem;\n           \n       }\n\n       .nav-item{\n        padding-right:40px;\n      \n    }\n    .nav-link {\n        font-weight:600 !important;\n        font-size:15px;\n        color:white !important;\n        text-align: center;\n       \n    }\n    .nav-link:hover { \n        background-color: #665;\n    }\n\n    .dropdown-menu{\n        width:300px;\n        padding:20px !important;\n    }\n\n    .dropdown-menu a{\n       text-decoration: none;\n        color:black;\n    }\n\n    .dropdown-menu a:hover{\n        text-decoration: none;\n         color:black;\n         background-color:#666655\n     }\n   @media(min-width:760px) {\n           .header_logo_logo {\n               margin-left: 0;\n               margin-right: 10rem\n           }\n       }\n       @media(max-width:990px){\n           #topNav{\n               display:none;\n            }\n       }\n       @media(max-width:760px) {\n       .header_logo_logo {\n           width: 70%;\n           \n         \n           \n       }\n      \n   }\n   \n      \n   .logo-image{\n       float:left;\n     padding-left:30px;\n     padding-bottom:5px;\n     max-width: 100%;\n     \n    padding-top:5px;\n   }\n   @media only screen and (max-width:530px) {\n       \n     .logo-image\n     {\n       padding-left:0px;\n     }\n       }\n  .aclintranet_subpage{\n           width:90%;\n           margin: auto;\n       }\n  /****************************** Footer *****************************************/\n.footer__content {\n       background-color :#08508F;\n       display: -webkit-box;\n       display: -ms-flexbox;\n       display: flex;\n       -webkit-box-orient: vertical;\n       -webkit-box-direction: normal;\n       -ms-flex-direction: column;\n       flex-direction: column;\n       -webkit-box-align: center;\n       -ms-flex-align: center;\n       align-items: center;\n       padding: 3rem;\n       z-index:100;\n       \n   }\n   @media(min-width:320px) {\n       .footer__content {\n           -webkit-box-orient: horizontal;\n           -webkit-box-direction: normal;\n           -ms-flex-direction: row;\n           flex-direction: row;\n           -webkit-box-pack: justify;\n           -ms-flex-pack: justify;\n           justify-content: space-between\n       }\n   }\n\n   #footer a{\n       color:white;\n       line-height: 20px;\n       font-size:14px !important;\n   }\n   #footer a:hover {\n       color: black;\n       text-decoration: underline;\n   }\n   \n   a {\n      \n       text-decoration: none;\n   }\n   \n   .footer__content ul {\n       list-style-type: none\n   }\n   \n   .footer__content h3 {\n       margin-top: 0;\n       font-size: 1.2rem;\n       font-family: source-sans-pro,helvetica,arial,sans-serif\n   }\n   \n   .footer__content li {\n       font-size: 1.0rem\n   }\n   \n   .footer__content__section {\n       display: -webkit-box;\n       display: -ms-flexbox;\n       display: flex;\n       -webkit-box-orient: horizontal;\n       -webkit-box-direction: normal;\n       -ms-flex-flow: row wrap;\n       flex-flow: row wrap\n   }\n   \n   .footer__content__section--links div {\n       margin-right: 3rem;\n       margin-bottom: 3rem\n       }\n   \n   .footer__content__section--logos {\n       margin-bottom: 3rem\n   }\n   \n    \n   .footer__content__section--logos li {\n           width: 15rem;\n           text-align: center\n       }\n   \n     @media only screen and(max-width:760){\n   \n           .footer__content__section--logos ul li {\n               padding-bottom:100px;\n       }\n       }\n   \n   @media(min-width:320px) {\n       .footer__content__section--logos {\n           -webkit-box-ordinal-group: 5;\n           -ms-flex-order: 4;\n           order: 4;\n           justify-self: flex-end\n       }\n   }\n   \n   .footer__content__section footer__content__section--links ul li a {\n       text-decoration: none;\n   }\n\n   .nav-link {\n    font-weight:600 !important;\n    font-size:16px;\n    color:black !important;\n    text-align: center;\n   \n}\n   /* ********************************* Responsive Table ********************************** */\n   .logo-image{\n    float:left;\n  padding-left:30px;\n  padding-bottom:5px;\n  max-width: 100%;\n  Width:250px;\n  \n padding-top:5px;\n}\n@media only screen and (max-width:530px) {\n    \n  .logo-image\n  {\n    padding-left:0px;\n  }\n    }\n   \n\n    .modal {\n        font-size: 12px;\n      }\n      .modal > .header {\n        width: 100%;\n        border-bottom: 1px solid gray;\n        font-size: 18px;\n        text-align: center;\n        padding: 5px;\n      }\n      .modal > .content {\n        width: 100%;\n        padding: 10px 5px;\n      }\n      .modal > .actions {\n        width: 100%;\n        padding: 10px 5px;\n        margin: auto;\n        text-align: center;\n      }\n      .modal > .close {\n        cursor: pointer;\n        position: absolute;\n        display: block;\n        padding: 2px 5px;\n        line-height: 20px;\n        right: -10px;\n        top: -10px;\n        font-size: 24px;\n        background: #ffffff;\n        border-radius: 18px;\n        border: 1px solid #cfcece;\n      }\n\n      .demo-root {\n        width: 90%;\n        display: flex;\n        font-family: Roboto;\n        align-items: center;\n        flex-direction: column;\n        justify-content: center;\n      }\n      .demo-label {\n        display: block;\n        font-size: 20px;\n        font-weight: 500;\n        margin: 50px 0 25px;\n      }\n      .demo-label-high {\n        display: block;\n        font-size: 20px;\n        font-weight: 500;\n        margin: 50px 0 90px;\n      }\n      .demo-subLabel {\n        margin-bottom: 20px;\n      }\n      .demo-editorSection {\n        display: flex;\n        justify-content: space-between;\n      }\n      .demo-wrapper {\n        width: 100% !important;\n        display: block !important;\n        margin-bottom: 25px !important;\n        height: 400px !important;\n      }\n      .demo-wrapper-medium {\n        width: 650px !important;\n        display: block !important;\n        margin-bottom: 50px !important;\n        height: 300px !important;\n      }\n      .demo-editor {\n        height: 275px !important;\n        border: 1px solid #C0C0C0 !important;\n        padding: 5px !important;\n        border-radius: 2px !important;\n      }\n      .demo-editorWrapper {\n      }\n      .demo-content {\n        border: 1px solid #F1F1F1;\n        padding: 5px;\n        border-radius: 5px;\n        width: 100%;\n        border-radius: 2px;\n        resize: none;\n        height: 200px;\n      }\n\n  \n\n      \n      .rdw-editor-toolbar[aria-hidden=\"false\"] {\n        visibility: visible;\n        height: auto; /* Element is visible and takes up its natural height */\n      }\n      \n      /* When aria-hidden is set to \"true\" */\n      .rdw-editor-toolbar[aria-hidden=\"true\"] {\n        visibility: hidden;\n        height: 0; /* Element is hidden and its height is collapsed */\n      }\n      .demo-toolbar-absolute {\n       \n        top: 120px !important;\n        width: 550px !important;\n        border-radius: 3px !important;\n        background: #f3f3f3 !important;\n        border: 1px solid #e3e3e3 !important;\n      }\n      .demo-toolbar-absolute-high {\n        position: absolute !important;\n        top: -80px !important;\n        width: 550px !important;\n        border-radius: 3px !important;\n        background: #f3f3f3 !important;\n        border: 1px solid #e3e3e3 !important;\n      }\n      .demo-editor-plain {\n        height: 80% !important;\n        border-width: 0px !important;\n      }\n      .demo-editor-embedded {\n        height: 90% !important;\n        border-width: 0px !important;\n      }\n      .demo-wrapper-relative {\n        display: block !important;\n        position: relative !important;\n        margin-bottom: 25px !important;\n        height: 200px !important;\n      }\n      .demo-wrapper-relative-long {\n        width: 715px !important;\n        display: block !important;\n        position: relative !important;\n        margin-bottom: 25px !important;\n        height: 450px !important;\n      }\n      .bordered-option-classname {\n        border: 1px solid #e3e3e3 !important;\n      }\n      .demo-toolbar-absolute > div:not(:last-of-type) {\n        border-right: 2px solid #e3e3e3;\n        padding-right: 5px;\n      }\n      .demo-toolbar-absolute > div:not(:first-of-type) {\n        padding-left: 5px;\n      }\n      .demo-toolbar-custom {\n        border-color: rgb(0,47,126) !important;\n        background-color: #9EBEF5 !important;\n      }\n      .demo-editor-custom {\n        height: 200px !important;\n        border: 1px solid #c0bbbb !important;\n        padding: 5px !important;\n        height: 75% !important;\n        border-radius: 2px !important;\n        border-color: rgb(0,47,126) !important;\n      }\n      .demo-option-custom {\n        width: 15px !important;\n        height: 15px !important;\n        border-color: rgb(0,47,126) !important;\n        color: rgb(0,47,126);\n      }\n      .demo-option-custom-wide {\n        width: 125px !important;\n        height: 25px !important;\n        border-color: rgb(0,47,126) !important;\n        color: rgb(0,47,126) !important;\n      }\n      .demo-option-custom-medium {\n        height: 25px !important;\n        border-color: rgb(0,47,126) !important;\n        color: rgb(0,47,126) !important;\n      }\n      .demo-dropdown-custom {\n        border-color: rgb(0,47,126) !important;\n      }\n      .demo-popup-custom {\n        border-color: rgb(0,47,126) !important;\n        padding: 5px !important;\n      }\n      .demo-popup-custom input {\n        border-color: rgb(0,47,126) !important;\n      }\n      .demo-popup-custom button {\n        border-color: rgb(0,47,126) !important;\n      }\n      .demo-section-wrapper {\n        display: flex;\n      }\n      .demo-editor-wrapper {\n        width: 60%;\n      }\n      .demo-section {\n        margin: 50px 30px 20px;\n        width: 95%;\n      }\n      .ReactCodeMirror {\n        width: 38%;\n        margin-left: 2%;\n        border: 1px solid #e4e4e4;\n        height: 400px;\n      }\n      .CodeMirror {\n        height: 400px !important;\n      }\n      .demo-custom-option {\n        width: 26px;\n        height: 26px;\n        border: 1px solid #f1f1f1;\n        text-align: center;\n        padding-right: 5px;\n        padding-bottom: 2px;\n        cursor: pointer;\n      }\n      .DraftEditor-editorContainer{\n        font-size:16px;\n      }\n      \n      .blue-black-card {\n        background-color: #0557aa;  /* blue-black background */\n        color: white;  /* text color */\n        border-radius: 10px;\n        padding: 20px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n        height:300px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    }\n    \n    .blue-black-card:hover {\n      background-color: #2086ec;  \n    }\n\n    .blue-black-button {\n      background-color: #0557aa;  \n    }\n\n    .blue-black-button:hover {\n      background-color: #2086ec;  \n    }\n    .icon-container {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-bottom: 10px;\n    }\n    a.block:hover{\n      text-decoration: none;\n    }\n\n    .usa-banner__inner {\n      margin-left: inherit !important;\n    }\n\n  #react-select-3-placeholder{\n      color: #333\n  }\n  .css-1jqq78o-placeholder {\n    color: #333 !important\n}\n.css-1fw11w8-Button{\ncolor: black !important\n}\n\n.rdw-dropdown-selectedtext img::after {\n  content: \"Font Size Icon\" !important\n}\n\n.rdw-dropdown-selectedtext img {\n  content: \"Font Size Icon\" !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
